import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { pathWithParams } from '../../../lib/routing.utils';
import { RouteIndex } from '../../routeIndex';

const CheckoutView = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(pathWithParams(RouteIndex.topUpCredit, {}), { replace: true });
    }, [navigate]);

    return null;
};

export default CheckoutView;
